import cloneDeep from 'lodash.clonedeep';
import { select, put, PutEffect, SelectEffect } from 'redux-saga/effects';

import { SetElementsLoopsAction, updateScribe } from 'js/actionCreators/scribeActions';

import { getScribeById } from '../selectors';

export function* updateElementsLoops({
  scribeId,
  elementIds,
  value
}: SetElementsLoopsAction): Generator<SelectEffect | PutEffect, void, ReturnType<typeof getScribeById>> {
  const scribe = yield select(state => getScribeById(state, scribeId));

  if (!scribe) return;

  const scribeClone = cloneDeep(scribe);
  scribeClone.elements.forEach(el => {
    if ('emphasisAnimationLoops' in el && elementIds.includes(el.id)) {
      el.emphasisAnimationLoops = Math.round(value);
    }
  });
  yield put(updateScribe(scribeClone));
}
